import React, { useState, createRef, PureComponent } from 'react';
import {  Button, Menu, Input, Col, Row, notification, Result } from 'antd';
import { LockFilled, LeftOutlined } from '@ant-design/icons';
import Browser from './Browser';
import IPConfigPage from './IPConfigPage';

const strengthIconMap = {
  '节能': require('../../assets/signal/eco.svg'),
  '标准': require('../../assets/signal/normal.svg'),
  '穿墙': require('../../assets/signal/full.svg'),
};

export class WIFIPage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedAPRecord: null
    };

    ['onSelectAP', 'onGoBack', 'onJoinAP'].forEach((func) => this[func] = this[func].bind(this));

    this.passwordRef = createRef();
  }

  // 当选中AP时切换至详情画面
  onSelectAP(apRecord) {
    this.setState({ selectedAPRecord: apRecord });
  }

  // 当返回时
  onGoBack() {
    this.setState({ selectedAPRecord: null});
  }

  // 当加入AP网络时
  async onJoinAP() {
    const { state, props, passwordRef } = this;

    // 获取SSID
    const { selectedAPRecord } = state;
    const { SSID } = selectedAPRecord;

    // 获取输入密码：可能为非加密模式，此时密码为空字符串
    const password = passwordRef.current ? passwordRef.current.input.value: '';

    // 获取WIFI设备
    const { device } = props;

    try {
      // 连接WIFI
      // debugger;
      await device.connect(SSID, password);
    }
    catch(e) {
      notification.error({
        message: `尝试加入无线网络${SSID}时出错`,
        description: e.message,
      });
    }

    // 返回
    this.onGoBack();
  }

  render() {
    const { state, props, passwordRef } = this;
    const { device } = props;
    const { selectedAPRecord } = state;

    // 如果没有选中记录，则列表模式，否则输入密码模式
    if(selectedAPRecord) {
      const { SSID, encryptMode } = selectedAPRecord;
      return (
      <div>
        <Row>
          <LeftOutlined style={{fontSize: '22px', marginTop: '10px'}} onClick={()=> {
            this.setState({
              selectedAPRecord: null,
            });
          }}/>
          <p style={{textAlign: 'center', margin:'10px auto', fontSize: '16px', color: '#333333'}}>{SSID}</p>                   
        </Row>
        <hr style={{width: '404px',height: '2px',background: '#D5DDE5'}}></hr>
        {
          encryptMode !== 'none' ? (
            <div>
              <p style={{marginTop:'20px', fontSize: '16px', color: '#333333'}}>密码：</p>
              <Input.Password
                ref={passwordRef}
                style={{
                  width: '404px',
                  height: '49px',
                  border: '1px solid #C2D1E8',
                  borderRadius: '6px',
                }
              }></Input.Password>
            </div>
          ): <h4>该热点没有配置加密模式，通信可能被窃听，请谨慎使用！</h4>
        }
        <Button 
          type="primary" 
          onClick={this.onJoinAP}
          style={{
            position: 'absolute',
            width: '404px',
            height: '49px',
            background: '#1B6FED',
            borderRadius: '6px',
            margin: '0 auto',
            bottom: '10px',
          }}
        >加入</Button>
      </div>
      );
    }
    else {
      const apRecords = device?.scan?.() || [];
      if(0 === apRecords.length) {
        return (
          <Result
            status="warning"
            title="没有搜索到可用的WIFI接入点"
          />
        );
      }

      return apRecords.map(apRecord => {
        const { SSID, encryptMode, strength, connected } = apRecord;
        const strengthIcon = strengthIconMap[strength];

        return (
          <Row key={SSID} style={{ cursor: 'pointer' }} align="middle" onClick={() => { this.onSelectAP(apRecord) }}>
            <Col span={3}>
              <img alt={strength} src={strengthIcon} style={{margin: '10px', width:'28px'}} />
            </Col>
            <Col span={17}>
              <span style={{fontSize: '18px', color: connected ? 'blue': undefined}}>{SSID}</span>
            </Col>
            <Col span={4}>{encryptMode !== 'none' ? <LockFilled style={{margin: '10px', fontSize:'20px', lineHeight: '20px'}}/> : null }</Col>
        </Row>
        )
      });
    }

  }
}

export const MobileDevice = (props) => {
  const [menuKey, setMenuKey] = useState('无线网络');
  const { device } = props;

  return (
    <div>
      <style>
      {
          `
          .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item:hover, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu:hover, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-active, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-active, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-open, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-open, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected, .ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-selected {
              background-color: #1B6FED !important;
              color: #FFFFFF;
          }

          .ant-input-suffix {
            margin-left: 4px;
            color: #ADBCCB;
          }
          .ant-select:not(.ant-select-customize-input) .ant-select-selector {
            position: relative;
            background-color: #fff;
            border: 1px solid #d9d9d9;
            border-radius: 2px;
            -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
            transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
            height: 49px !important;
          }

          .ant-select-single.ant-select-open .ant-select-selection-item {
            color: #bfbfbf;
            line-height: 49px !important;
          }

          .ant-select-single.ant-select-show-arrow .ant-select-selection-item, .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
            padding-right: 18px;
            line-height: 49px;
          }

          .ant-modal-title {
            margin: 0;
            color: rgba(0, 0, 0, 0.85);
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            word-wrap: break-word;
            text-align: center;
          }
          `
      }
      </style>
      <div
        style={{
          width: '461px',
          height: '587px',
          background: '#408CEE',
          borderRadius: '38px',
          margin: '0 auto',
          paddingTop: '10px',
        }}>
          <div style={{
              width: '82px',
              height: '10px',
              background: '#071C38',
              borderRadius: '5px',
              margin: '10px auto',
          }}></div>
          <div 
            style={{
              padding: '10px',
              borderRadius: '20px',
              backgroundColor: '#ecf3fb',
              width: '426px',
              height: '500px',
              margin: '20px auto',
              position: 'relative',
            }}
          >
            <Menu onClick={(e) => setMenuKey(e.key)} selectedKeys={[menuKey]} defaultSelectedKeys={['连接']} mode="horizontal" style={{background: '#ECF3FA',}}>             
                <Menu.Item key="无线网络" style={{
                    width: '92px',
                    height: '45px',
                    background: '#C2D1E8',
                    borderRadius: '36px',
                    textAlign: 'center',
                    }}>
                无线网络
                </Menu.Item>
                <Menu.Item key="IP配置" style={{
                    width: '92px',
                    height: '45px',
                    background: '#C2D1E8',
                    borderRadius: '36px',
                    textAlign: 'center',
                    }}>
                IP配置
                </Menu.Item>
                <Menu.Item key="浏览器" style={{
                    width: '92px',
                    height: '45px',
                    background: '#C2D1E8',
                    borderRadius: '36px',
                    textAlign: 'center',
                    }}>
                浏览器
                </Menu.Item>
            </Menu>
            <hr style={{color: '#D5DDE5',}}></hr>
            { menuKey === '无线网络' ? <WIFIPage device={device} />:null}
            { menuKey === 'IP配置' ? <IPConfigPage device={device} />:null}
            { menuKey === '浏览器' ? <Browser device={device} />:null}
          </div>
        </div>
    </div>
  );
};

